import React, { Fragment, useMemo } from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import Icon from 'particles/Icon'
import SocialMediaPlatformIcon from '../common/SocialMediaPlatformIcon'
import { PLATFORM_ENUM } from 'services/api/constants'

interface PlatformIconListProps {
    platforms: PLATFORM_ENUM[]
    color: string
    iconSize?: number
    separatorSize?: number
    itemContainerStyle?: StyleProp<ViewStyle>
}

const PlatformIconList: React.FC<PlatformIconListProps> = ({ platforms, itemContainerStyle }) => {
    const socialMediaPlatforms = useMemo(
        () => platforms?.filter(platform => platform !== PLATFORM_ENUM.OTHER) ?? [],
        [platforms],
    ) as Exclude<PLATFORM_ENUM, PLATFORM_ENUM.OTHER>[]
    return (
        <Fragment>
            {socialMediaPlatforms.map((platform, index) => (
                <Fragment key={index}>
                    <View style={itemContainerStyle}>
                        <SocialMediaPlatformIcon platform={platform} />
                    </View>

                    {index !== socialMediaPlatforms.length - 1 && (
                        <Icon size="8px" name={'dot'} color={'neutralActionActive'} />
                    )}
                </Fragment>
            ))}
        </Fragment>
    )
}

export default PlatformIconList
